<template>
  <div class="hb-check-platform-page">
    <div class="desc">{{ stateDesc() }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        state:2
    };
  },
  mounted() {
    this._isMobile()
  },
  methods: {
    _isMobile() {
      // let flag = navigator.userAgent.match(
      //   /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      // );
      // if (flag) {
      //   // 移动端
      //   this.state = 1
      // } else {
      //   // 跳转
      //   this.state = 2
      //   this.$router.push('/')
      // }
      this.state = 2
      this.$router.push('/')
    },
    stateDesc() {
        if (this.state == 0) {
            return '运行环境监测中...'
        } else if (this.state == 1) {
            return "当前运行环境为移动端，如需登录系统，请切换至电脑"
        } else {
            return '当前运行环境为电脑端'
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.hb-check-platform-page {
    .desc {
        color:red;
        size: 20px;
        width: 100%;
        text-align: center;
        padding: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/checkPlatform/index.vue